import React from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import TutorSidebar from 'src/components/tutor/Sidebar';
import UserNavbar from 'src/components/ui/UserNavbar';
import { usePageHeaderStore } from "src/store/pageHeaderStore";

interface LayoutContext {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}

const TutorPageLayout = () => {
  const context = useOutletContext<LayoutContext>();
  const { title = "Tutor Dashboard", description, actions } = context || {};
  const { title: pageTitle, description: pageDescription, actions: pageActions } = usePageHeaderStore();

  return (
    <div className="app-layout bg-gray-50">
      <div className="sidebar">
        <TutorSidebar />
      </div>
      <div className="content-area">
        <UserNavbar
          title={pageTitle}
          description={pageDescription}
          actions={pageActions}
          className="px-0 py-0 border-0"
        />

        <main className="flex-grow py-6 px-6 overflow-y-auto">
          <div className="max-w-7xl mx-auto">
            {description && (
              <p className="mt-2 text-lg text-gray-500 mb-6">
                {description}
              </p>
            )}
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default TutorPageLayout;
